<template>
    <button
        v-show="visible"
        class="dn-button base-button scroll-to-top"
        aria-label="Scroll top top"
        @click="scrollTop"
    >
        <BaseIcon
            class="scroll-to-top__icon dn-icon--square"
            icon="chevron-up"
        />
    </button>
</template>

<script setup lang="ts">
const { visible } = useScrollUpPosition();

const scrollTop = () => window.scrollTo({
    top: 0,
    behavior: 'smooth',
});
</script>

<style lang="less">
.scroll-to-top {
    .typography-label-secondary;
    position: fixed;
    width: 3rem;
    height: 3rem;
    bottom: 1rem;
    right: 1rem;
    cursor: pointer;
    z-index: 3;
    color: var(--color-text-secondary);
    transition: color var(--transition-fast);

    &:hover, &:focus {
        color: var(--color-primary);
    }

    &:active {
        color: var(--color-primary-dark);
    }
}

.dn-button .dn-icon.scroll-to-top__icon {
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0;
}

.dn-icon.scroll-to-top__icon {
    transform: translate(-50%, -50%);
    transition: transform var(--transition-fast);

    .scroll-to-top:hover & {
        transform: translate(-50%, -60%);
    }
}
</style>
